import React, { useState } from "react";
import styles from "../../TalentApplication/styles.module.css";
import logoWhite from "../../../assets/images/schmodelplain-withR-white.png";
import WithUserForm from "../../Register/WithUserForm";
import { required } from "../../../utils/validate";
import PhoneNumberInput, {getCountryCallingCode} from "react-phone-number-input";
import {parsePhoneNumberFromString} from "libphonenumber-js"
import {CountryCode} from "../../TalentApplication/StepDetails_1st";
import {libphonenumberFilteredMetadata} from "../../TalentApplication/StepDetails_1st/twilio-geo-permissions";
import {useForm} from "react-hook-form";
import {Link} from "react-router-dom";
import stylesButton from "../../utils/css/button.module.css";

const WebLogin  = () => {
    const {
        register,
        formState: { errors },
        setError,
        clearErrors,
        trigger
    } = useForm()

    const [email, setEmail] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [isAppReviewerEmail, setIsAppReviewerEmail] = useState(false);
    const webLogin = async (props) => {
        clearErrors(["response"]);
        const valid = await trigger();
        if (!valid) return;
        if (!phoneNumber) {
            setError("phoneNumber", { message: "Phone number is required" });
            return;
        }
        if (!valid || !phoneNumber) return;
        const parsed = parsePhoneNumberFromString(phoneNumber);
        if (!parsed?.isValid()) {
            setError("phoneNumber", { message: "Invalid phone number" });
            return;
        }

        try {
            const response = await props.webLogin({
                variables: {
                    email,
                    phoneNumber
                },
            });
            window.location.href = `${window.location.origin}/apply/verification?session=${encodeURIComponent(response.data.webLogin.token)}`;
        } catch (error){
            setError("response", { message: error.message });
        }

    }


    return (
        <WithUserForm
            formRequiresAuthentication={false}
            onSubmit={(values, dispatch, props, self) => {
                webLogin(props)
            }}
        >
            {({form: {handleSubmit}, userQuery: {data}}) => {
                return (
                    <div
                        style={{
                            height: "100%",
                            width: "100%",
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                        className='top-0 left-0 w-full h-full overflow-hidden'
                    >

                        <div className={styles.step_header_container}>
                            <img src={logoWhite} className={styles.step_logo} alt="img" />
                        </div>
                        <form
                            onSubmit={handleSubmit}
                            style={{
                                width:' 90vw',
                                maxWidth: '400px',
                                flex: 0,
                                position: "relative",
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <p style={{
                                color: "#B08D57",
                                textAlign: 'center',
                                fontSize: 'clamp(9px, 2vh, 14px)'
                            }}>Don't have an account?</p>
                            <Link to="/apply">
                                <p
                                    style={{
                                        color: "white",
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        fontSize: 'clamp(9px, 2vh, 14px)',
                                        textDecoration: 'underline',
                                        marginBottom: '10px'
                                    }}
                                >Click here to apply</p>
                            </Link>
                            {errors.response && (
                                <div className="text-red-500 text-sm">
                                    <p className={`${styles.default_text_size} text-red-500 text-center`} style={{ marginBottom: '10px' }}>
                                        {errors.response?.message || 'placeholder'}
                                    </p>
                                </div>
                            )}

                            <input
                                type="email"
                                placeholder="Email"
                                {...register("email", {
                                    required: "Email is required",
                                    pattern: {
                                        value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                        message: "Invalid email",
                                    }
                                })}
                                onChange={(e) => {
                                    setIsAppReviewerEmail(e.target.value === process.env.REACT_APP_APP_REVIEWER_EMAIL);
                                    setEmail(e.target.value)
                                    clearErrors( ["email", "response"]);
                                }}
                                className={`${styles.input} ${styles.default_text_size}`}
                                style={{
                                    marginBottom: '15px',
                                    borderColor: errors.email ? "#e53935" : "#B08D57"
                                }}
                            />
                            {/*appreview@schmodel.com*/}
                            {isAppReviewerEmail && <div  className={`${styles.default_text_size} w-full text-red-500 mt-2 text-center`}>
                                <span className="ml-1">You’ve been identified as an app reviewer, please</span>
                                <Link to="/account" className="ml-1 underline cursor-pointer">click here to log in</Link>
                            </div>}
                            {!isAppReviewerEmail && <>
                                <PhoneNumberInput
                                    className={`${styles.combobox_phone_number} ${errors.phoneNumber && styles.phone_number_error} ${styles.default_text_size}`}
                                    style={{
                                        marginBottom: '0px'
                                    }}
                                    name="phoneNumber"
                                    validate={[required]}
                                    placeholder="Phone"
                                    country={"GB"}
                                    limitMaxLength={true}
                                    flagComponent={({country}) => (
                                        <CountryCode country={country}/>
                                    )}
                                    value={phoneNumber}
                                    metadata={libphonenumberFilteredMetadata()}
                                    international={false}
                                    displayInitialValueAsLocalNumber={true}
                                    type="tel"
                                    onChange={(value) => {
                                        if (value) {
                                            const parsed = parsePhoneNumberFromString(value);
                                            if (parsed?.isValid()) {
                                                const localNumber = parsed.nationalNumber;
                                                const formatted = parsed.country ? `+${getCountryCallingCode(parsed.country)} ${localNumber}` : value;
                                                setPhoneNumber(formatted);
                                            } else {
                                                setPhoneNumber(value);
                                            }
                                        } else {
                                            setPhoneNumber('');
                                        }
                                        clearErrors(["phoneNumber", "response"]);
                                    }}
                                    isRequired={true}
                                />
                                <div className='h-7 w-full flex justify-center my-3'>
                                    {errors.email && <p className={`${styles.default_text_size} text-red-500`}>{errors.email.message}</p>}
                                    {!errors.email && errors.phoneNumber &&
                                        <p  className={`${styles.default_text_size} text-red-500`}>{errors.phoneNumber.message}</p>}
                                </div>
                                <button
                                    type='submit'
                                    className={`${stylesButton.button} ${styles.default_text_size} `}
                                >
                                    Login
                                </button>
                            </>}
                        </form>
                        <div className={styles.step_footer_container}/>
                    </div>
                )
            }}
        </WithUserForm>
    );
}

export default WebLogin;